/**
 * Computer-use credential events (web)
 *
 * Bridge for private vault login cards. Secrets never enter chat text —
 * only a non-secret ack like "Credential saved for {domain}".
 */

// --------------

export const COMPUTER_USE_CREDENTIAL_EVENT = 'computer-use:credential-outcome'

// --------------

export type ComputerUseCredentialEventDetail =
  | {
      chatId: string
      domain: string
      status: 'saved'
      url?: string
    }
  | {
      chatId: string
      domain: string
      status: 'declined'
      url?: string
    }

// --------------

export function emitComputerUseCredentialOutcome(
  detail: ComputerUseCredentialEventDetail
) {
  window.dispatchEvent(
    new CustomEvent(COMPUTER_USE_CREDENTIAL_EVENT, { detail })
  )
}
